<template>
  <!-- {{ props.entry }} - {{ entrytype }} -->
  <div class="container">
    <div
      class="row d-flex align-items-center mt-2 mb-2"
      v-if="entrytype == 'attendance'"
    >
      <div class="row">
        <div class="col d-flex justify-content-center">
          <input
            type="date"
            id="txn_date"
            class="form-control date-field"
            placeholder="Date"
            :value="txn_date"
            @change="updateDate()"
          />
        </div>
      </div>
      <div class="row mt-1">
        <div class="col-6">
          <div class="input-group smalltxt">
            <input
              type="text"
              class="form-control"
              placeholder="Name..."
              v-model.trim="name"
            />
            <button
              class="btn btn-outline-secondary dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
            ></button>
            <ul class="dropdown-menu dropdown-menu-end">
              <li
                class="dropdown-item"
                href="#"
                v-for="n in names"
                :key="n"
                @click="setName(n)"
              >
                {{ n }}
              </li>
            </ul>
          </div>
        </div>
        <div class="col">
          <input type="text" class="form-control" v-model.number="att" />
        </div>
        <div class="col">
          <input type="text" class="form-control" v-model.number="rate" />
        </div>
      </div>
      <div class="row mt-1">
        <div class="col d-flex justify-content-center">
          <button
            class="btn btn-success btn-sm"
            v-if="att * rate"
            @click="updateAttendance()"
          >
            Update {{ att * rate }}
          </button>
        </div>
      </div>
    </div>
    <div class="row d-flex align-items-center mt-2 mb-2" v-else>
      <div class="row mt-2 d-flex align-items-center">
        <div class="col">
          <input
            type="date"
            id="txn_date"
            class="form-control date-field"
            placeholder="Date"
            :value="txn_date"
            @change="updateDate()"
          />
        </div>
        <div class="col">
          <button
            class="btn btn-secondary dropdown-toggle btn-sm"
            type="button"
            id="dropdownMenuButton1"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <span v-if="account_name">{{ account_name }}</span>
            <span v-else>Account</span>
          </button>
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li
              class="dropdown-item"
              v-for="a in store.accounts"
              :key="a.id"
              :class="{ 'bg-primary': account_id_new == a.id }"
              @click="selectAccount(a.id)"
            >
              {{ a.name }}
            </li>
          </ul>
        </div>
        <div class="col">
          <button
            class="btn btn-sm btn-success"
            v-if="txn_type == 'i'"
            @click="setTxnType('e')"
          >
            I
          </button>
          <button
            class="btn btn-sm btn-danger"
            v-if="txn_type == 'e'"
            @click="setTxnType('i')"
          >
            E
          </button>
        </div>
      </div>
      <div class="row mt-2 d-flex align-items-center">
        <div class="col">
          <input
            type="text"
            class="form-control fw-bold border border-2"
            :class="textColour"
            v-model.trim="textValue"
            @input="handleInput"
          />
        </div>
        <div class="col d-flex justify-content-around">
          <span
            class="badge rounded-pill bg-light text-dark"
            @click="toggleNote = !toggleNote"
            >Note</span
          >
          <span class="badge rounded-pill bg-light text-dark">Photo</span>
        </div>
        <div class="col">
          <button
            class="btn btn-sm btn-success"
            v-if="textValue"
            @click="updateEntry()"
          >
            Update
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col" v-if="!toggleNote">{{ note }}</div>
        <div class="col" v-else>
          <input type="text" class="form-control" v-model.trim="note" />
        </div>
      </div>
      <!-- NON ATTENDANCE ENTRIES-->
    </div>
  </div>
</template>

<script setup>
import { computed, defineProps, defineEmits, ref, onMounted } from "vue";
import { useStore } from "../../store/index";
import { doc, updateDoc, deleteField } from "firebase/firestore";
import { db } from "../../firebase/config";
const dayjs = require("dayjs");
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);
const store = useStore();
const props = defineProps(["entry"]);
const emits = defineEmits(["editDone"]);
const { customAlphabet } = require("nanoid");
const alphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
const nanoid = customAlphabet(alphabet, 6);
const name = ref("");
const att = ref(null);
const rate = ref(null);
const sortby = ref("desc");
const names = ref([]);
const textValue = ref("");
const account_id_new = ref("");
const txn_type = ref("");
const toggleNote = ref("false");
const note = ref("");
const updateEntry = async () => {
  const time_string = props.entry.d.split(" ")[1]; //this is done so that ordering of entry on that particular day does not change in display
  if (account_id_new.value != props.entry.account_id) {
    var txnObj = {
      n: note.value, //note
      a: parseInt(textValue.value), //amount
      t: txn_type.value, //txn type - i:income, e:expense
      p: null, //link to photo, if any
      // ts: serverTimestamp(), //timestamp
      //d: txn_date.value + " " + dayjs().format("HH:mm:ss"), //transaction date, with time (for sorting) - need not be present date, can be past or future
      d: txn_date.value + " " + time_string, //transaction date, with time (for sorting) - need not be present date, can be past or future
    };
    const accountRef = doc(db, "accounts", account_id_new.value); // add new journal entry to new account
    await updateDoc(accountRef, {
      ["journal." + nanoid()]: txnObj,
    });
    //delete previous entry
    setTimeout(() => {
      deleteEntry(props.entry.journal_id, props.entry.account_id);
      emits("editDone");
    }, 1000);
  } else {
    console.log("same account edit: ", props.entry.journal_id);
    var txnObj1 = {
      n: note.value, //note
      a: parseInt(textValue.value), //amount
      t: txn_type.value, //txn type - i:income, e:expense
      p: null, //link to photo, if any
      // ts: serverTimestamp(), //timestamp
      //d: txn_date.value + " " + dayjs().format("HH:mm:ss"), //transaction date, with time (for sorting) - need not be present date, can be past or future
      d: txn_date.value + " " + time_string, //transaction date, with time (for sorting) - need not be present date, can be past or future
    };
    const accountRef = doc(db, "accounts", props.entry.account_id);
    await updateDoc(accountRef, {
      ["journal." + props.entry.journal_id]: txnObj1,
    });
    setTimeout(() => {
      emits("editDone");
    }, 1000);
  }
};
const deleteEntry = async (jid, aid) => {
  console.log(jid, aid);
  const accountRef = doc(db, "accounts", aid);

  // Remove the 'capital' field from the document
  await updateDoc(accountRef, {
    ["journal." + jid]: deleteField(),
  });
};
const handleInput = () => {
  // Allow numbers, decimals, 'k', and 'l'
  const sanitized = textValue.value.replace(/[^0-9.kl]/gi, "");

  // Handle case for 'k' or 'l'
  if (/^\d*\.?\d+k$/i.test(sanitized)) {
    textValue.value = parseFloat(sanitized) * 1000; // Convert to numeric value
  } else if (/^\d*\.?\d+l$/i.test(sanitized)) {
    textValue.value = parseFloat(sanitized) * 100000; // Convert to numeric value
  } else {
    textValue.value = sanitized; // Remove invalid characters
  }
};
const setTxnType = (t) => {
  txn_type.value = t;
};
const account_name = computed(() => {
  var name = "";
  store.accounts.forEach((a) => {
    if (a.id == account_id_new.value) {
      name = a.name;
    }
  });
  return name;
});
const textColour = computed(() => {
  var col = "";
  if (txn_type.value == "e") {
    col = "text-danger";
  }
  if (txn_type.value == "i") {
    col = "text-success";
  }
  return col;
});
onMounted(() => {
  populateDataFields();
  populateNameList();
  initilizeAccountDetails();
});
const txn_date = ref("");
const initilizeAccountDetails = () => {
  account_id_new.value = props.entry.account_id;
  txn_type.value = props.entry.t;
  textValue.value = props.entry.a;
  note.value = props.entry.n;
};
const selectAccount = (id) => {
  account_id_new.value = id;
};
const populateDataFields = () => {
  txn_date.value = props.entry.d.split(" ")[0];
  name.value = props.entry.n.split("#")[0];
  att.value = props.entry.n.split("#")[1];
  rate.value = props.entry.n.split("#")[2];
};

const updateDate = () => {
  txn_date.value = document.getElementById("txn_date").value.trim();
};
const entrytype = computed(() => {
  var type = "";
  store.accounts.forEach((a) => {
    if (a.id == props.entry.account_id && a.attendance) {
      type = "attendance";
    }
  });
  return type;
});
function sortByField(arr, field) {
  if (sortby.value == "asc") {
    return arr.slice().sort((a, b) => {
      // Compare the values of the specified field
      if (a[field] > b[field]) {
        return 1;
      } else if (a[field] < b[field]) {
        return -1;
      } else {
        return 0;
      }
    });
  }
  if (sortby.value == "desc") {
    return arr.slice().sort((a, b) => {
      // Compare the values of the specified field
      if (a[field] < b[field]) {
        return 1;
      } else if (a[field] > b[field]) {
        return -1;
      } else {
        return 0;
      }
    });
  }
}
const populateNameList = () => {
  names.value = [];
  sorted_journal.value.forEach((sj) => {
    if (!names.value.includes(sj.n.split("#")[0]))
      names.value.push(sj.n.split("#")[0]);
  });
};
const sorted_journal = computed(() => {
  var arr = [];
  // journal.value = [];
  store.accounts.forEach((account) => {
    //when no account is selected for entry
    if (account.id == props.entry.account_id) {
      //get entries only for attendance account
      for (const property in account.journal) {
        arr.push({
          journal_id: property,
          ...account.journal[property],
        });
      }
    }
  });

  var sorted_arr = sortByField(arr, "d");
  return sorted_arr;
});
const setName = (n) => {
  if (name.value != n) {
    name.value = n;
  } else {
    name.value = "";
  }
};
const updateAttendance = async () => {
  if (name.value && att.value && rate.value) {
    var txnObj = {
      n: name.value + "#" + att.value + "#" + rate.value, //note
      a: parseInt(att.value * rate.value), //amount
      t: "e", //txn type - i:income, e:expense
      p: null, //link to photo, if any
      d: txn_date.value + " " + dayjs().format("HH:mm:ss"), //transaction date, with time (for sorting) - need not be present date, can be past or future
    };

    const accountRef = doc(db, "accounts", props.entry.account_id);
    await updateDoc(accountRef, {
      ["journal." + props.entry.journal_id]: txnObj,
    });
  }
  emits("editDone");
};
</script>
<style scoped>
.date-field {
  width: auto;
  min-width: 125px; /* Ensures a reasonable default width */
  padding: 0.1rem 0.1rem; /* Matches default form-control padding */
  box-sizing: border-box; /* Ensures padding doesn't affect width */
}
.smalltxt {
  font-size: 10px;
}
</style>
